import React from 'react'
import './styles.scss'

export const NoContentView = ({title, description = ''}) => {
  return (
    <div className='no-content'>
      <h3>{title}</h3>
      <br />
      <span>{description}</span>
    </div>
  )
}
